import React, { useState, useEffect } from "react";
import { Modal, Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
import {
  getSequenceAdvertisingType,
  getSequenceTimeToNextPoll,
} from "../../../services/CollectionsSvc";

const ConfigureSurveyModal = ({ show, onClose, onBack, onSave }) => {
  const [surveyName, setSurveyName] = useState("");
  const [timeToNextPoll, setTimeToNextPoll] = useState("None");
  const [advertising, setAdvertising] = useState("Off");
  const [timeToNextPollOptions, setTimeToNextPollOptions] = useState([]);
  const [advertisingOptions, setAdvertisingOptions] = useState([]);

  useEffect(() => {
    const fetchTimeToNextPollOptions = async () => {
      try {
        const options = await getSequenceTimeToNextPoll();
        setTimeToNextPollOptions(
          Array.isArray(options.data.data) ? options.data.data : []
        );
      } catch (error) {
        console.error("Failed to fetch Time to Next Poll options:", error);
      }
    };

    fetchTimeToNextPollOptions();
  }, []);

  useEffect(() => {
    const fetchAdvertisingOptions = async () => {
      try {
        const options = await getSequenceAdvertisingType();
        setAdvertisingOptions(
          Array.isArray(options.data.data) ? options.data.data : []
        );
      } catch (error) {
        console.error("Failed to fetch Advertising options:", error);
        setAdvertisingOptions([]);
      }
    };

    fetchAdvertisingOptions();
  }, []);

  const handleSave = () => {
    const surveyConfig = {
      surveyName,
      timeToNextPoll:
        timeToNextPollOptions.find(
          (option) => option.name === timeToNextPoll
        ) || null,
      advertisingType:
        advertisingOptions.find((option) => option.name === advertising) ||
        null,
    };

    if (!surveyName.trim()) {
      alert("Survey Name is required.");
      return;
    }

    onSave(surveyConfig);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="custom-modal-width"
      size="lg"
      keyboard={false}
    >
      <Modal.Header closeButton className="custom-modal-header">
        <Modal.Title>Configure Survey</Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom-modal-body">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="standard-dropdown-label">
              Survey Name
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter survey name"
              value={surveyName}
              onChange={(e) => setSurveyName(e.target.value)}
            />
          </Form.Group>

          <div className="standard-dropdown mb-3">
            <div className="standard-dropdown-label">Time to Next Poll</div>
            <DropdownButton
              title={timeToNextPoll}
              onSelect={(selectedTime) => setTimeToNextPoll(selectedTime)}
              className="w-100"
            >
              {timeToNextPollOptions.map((option) => (
                <Dropdown.Item key={option.id} eventKey={option.name}>
                  {option.name}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div className="standard-dropdown mb-3">
            <div className="standard-dropdown-label">Advertising</div>
            <DropdownButton
              title={advertising}
              onSelect={(selectedAd) => setAdvertising(selectedAd)}
              className="w-100"
            >
              {advertisingOptions.map((option) => (
                <Dropdown.Item key={option.id} eventKey={option.name}>
                  {option.name}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div className="button-container d-flex justify-content-between">
            <Button
              variant="outline-primary"
              onClick={onBack}
              className="custom-back-button w-50 me-4"
            >
              Back
            </Button>
            <Button variant="primary" onClick={handleSave} className="w-50">
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ConfigureSurveyModal;
